import script from "./SectionBMedical.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionBMedical.vue?vue&type=script&setup=true&lang=js"

import "./SectionBMedical.vue?vue&type=style&index=0&id=1d91793a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d91793a"]])

export default __exports__